/**
 * @file AdminDashboard.jsx
 * @description Main application interface with role-specific features
 * 
 * @section Responsibilities
 * - Manage role-based views
 * - Handle data aggregation
 * - Control real-time updates
 * - Manage user preferences
 * 
 * @section Dependencies
 * - Role Management: Access control
 * - Data Services: Information handling
 * - State Management: Global state
 * 
 * @section Integration Points
 * - Data API: Information retrieval
 * - Role System: Access control
 * - Notification System: Real-time updates
 * 
 * @section State Management
 * - dashboardData: Aggregated information
 * - loadingState: Data fetching
 * - errorState: Error handling
 * 
 * @section Events
 * - onDataUpdate: Data changes
 * - onError: Error handling
 * - onPreferenceChange: Settings updates
 * 
 * @section Props
 * @prop {String} userRole - Current user role
 * @prop {Object} permissions - User permissions
 */

import React from "react";
import SkinPage from "../../SkinPage";
import ToAllocateClients from "../../widgets/clients/ToAllocateClients";
import AdminMyClients from "./AdminMyClients";

function AdminDashboard() {
  return (
    <SkinPage>
      <AdminMyClients />
      {/* <ToAllocateClients allocation={"advisor"}></ToAllocateClients> */}
    </SkinPage>
  );
}

export default AdminDashboard;
